// removed by extract-text-webpack-plugin
module.exports = {"button":"_2GfnORWX"};


//////////////////
// WEBPACK FOOTER
// ./app/account/containers/reset-password/reset-password.component.scss
// module id = 381
// module chunks = 0